/*
 * Dates in the UI. Activity timestamps show in the viewer's time zone. A
 * certificate's issue date is fixed in the zone it was issued in (see
 * formatCertificateDate in @ready/shared), so it matches the PDF everywhere.
 */
export { formatCertificateDate } from '@ready/shared';

/** The browser's IANA time zone, e.g. "Asia/Kolkata". */
export function browserTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/** "October 12, 2026" in the viewer's zone. */
export function formatDate(at: string | Date): string {
  return new Date(at).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}

/** "Oct 12, 2026, 9:14 PM" in the viewer's zone. */
export function formatDateTime(at: string | Date): string {
  return new Date(at).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

/** "9:14 PM" in the viewer's zone, with the zone's short name ("9:14 PM EDT"). */
export function formatTimeWithZone(at: string | Date): string {
  return new Date(at).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });
}

/** Every IANA zone the browser knows, for the Account setting. */
export function allTimeZones(): string[] {
  return typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : [];
}
